import type { VFC } from "react";
import { useState } from "react";
import { FormattedMessage } from "react-intl";

import { HorizontalTabs, Tab } from "../shared/HorizontalTabs";

import { NotificationList } from "./NotificationList";
import { ServiceNotificationList } from "./ServiceNotificationList";
import { UnreadBadge } from "./UnreadBadge";

import type { GetNotificationsQuery, ListServiceNotificationsQuery } from "~/client/generated/schema";

type Props = {
  isNotificationsLoaded: boolean;
  isNotificationsLoadError: boolean;
  notifications: GetNotificationsQuery["notifications"];
  serviceNotifications?: ListServiceNotificationsQuery["serviceNotifications"]["nodes"];
  unreadServiceNotification: boolean;
  onReadServiceNotifications: () => void;
  intl: any;
};

export const NotificationTabs: VFC<Props> = ({
  isNotificationsLoaded,
  isNotificationsLoadError,
  notifications,
  serviceNotifications,
  unreadServiceNotification,
  onReadServiceNotifications,
  intl,
}) => {
  const [tab, setTab] = useState("notification");

  return (
    <HorizontalTabs tabClassName="notificationTab" panelClassName="notificationPanel">
      <Tab
        active={tab === "notification"}
        label={
          <p>
            <FormattedMessage id="notificationTabs.notification" />
          </p>
        }
        onButtonClick={() => setTab("notification")}
        tabItemClassName="notificationTab__item"
        buttonClassName="horizontalTab-button--border notificationTab__item__button"
      >
        <NotificationList
          isLoaded={isNotificationsLoaded}
          isError={isNotificationsLoadError}
          notifications={notifications}
        />
      </Tab>
      <Tab
        active={tab === "serviceNotification"}
        label={
          <p className="notificationTab__label">
            <FormattedMessage id="notificationTabs.serviceNotification" />
            <UnreadBadge unread={unreadServiceNotification} className="notificationTab__label__unreadBadge" />
          </p>
        }
        onButtonClick={() => {
          onReadServiceNotifications();
          setTab("serviceNotification");
        }}
        tabItemClassName="notificationTab__item"
        buttonClassName="horizontalTab-button--border notificationTab__item__button"
      >
        <ServiceNotificationList locale={intl.locale} notifications={serviceNotifications} />
      </Tab>
    </HorizontalTabs>
  );
};
